/**
 * Where the seconds before the first screen actually go.
 *
 * Boot cost is not guessable from here: it depends on how big a library the
 * device holds, how fast its IndexedDB is, and what the network did — and a
 * report of "six to ten seconds" cannot be acted on without knowing which of
 * those it was. Each stage marks itself, and the first painted screen logs one
 * line naming them, so the answer comes from the device that is slow.
 *
 * Marks only, and one console line. No UI, no beacon, nothing sent anywhere.
 */
const marks = new Map<string, number>();
let reported = false;

export function markBoot(stage: string): void {
  if (marks.has(stage)) return;
  marks.set(stage, Math.round(performance.now()));
}

/**
 * Log the breakdown once, when a screen first has content.
 *
 * Called from every screen's first render rather than from a timer: "when did
 * something appear" is the only definition of ready that matches what a person
 * waiting is measuring.
 */
export function reportBoot(screen: string): void {
  if (reported) return;
  reported = true;
  const at = Math.round(performance.now());
  const parts = [...marks.entries()].map(([stage, ms]) => `${stage} ${ms}ms`);
  // console.info rather than a thrown breadcrumb: this is for reading, not
  // for alerting, and it must never be mistaken for an error.
  console.info(
    `[boot] ${screen} painted at ${at}ms · ${parts.join(" · ") || "no stages marked"}`,
  );
}
